"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddDisplayToDisplaysListDto = void 0;
class AddDisplayToDisplaysListDto {
    displayIds;
}
exports.AddDisplayToDisplaysListDto = AddDisplayToDisplaysListDto;
